export default "__VITE_ASSET__BUe9tses__"